'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconNamePropType = getIconNamePropType;

var _react = require('react');

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propType = void 0;

function getIconNamePropType() {
  if (!propType) {
    // Optimization: Since prop types are only validated in dev mode, omit icon names in production.
    /* eslint-disable no-undef */
    var iconNames = process.env.NODE_ENV === 'production' ? [] : require('icons/iconNames');
    /* eslint-enable no-undef */

    propType = _react.PropTypes.oneOf(iconNames);
  }

  return (0, _createChainablePropType2.default)(propType, 'iconName');
}